'use client';
import React from 'react';
import GardeniaContainer from '../GardeniaContainer';
import { LeadForm } from './LeadForm/LeadForm';
import { getAssetUrl } from '@utils/getAssetUrl';
import { getLeadGenerationOptions } from '@services/properties/getLeadGenerationOptions';

import cn from './style.module.scss';

export const GARDENIA_BAY_ID = 'gardenia-bay-registration';
export const scrollToYasRivaRegisterForm = () => {
  const el = document.getElementById(GARDENIA_BAY_ID);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
};
export default function GardenLaunchRegistration(props: any) {
  const [countryCode, setCountryCode] = React.useState<{}[]>([]);
  const [nationalities, setNationalities] = React.useState<{}[]>([]);

  const { t } = props;

  const leadMetaRequest = React.useMemo(() => getLeadGenerationOptions(), []);

  const setLeadMetaData = async () => {
    const { countryCode, nationalities } = await leadMetaRequest.getResponse();
    setNationalities(nationalities);
    setCountryCode(countryCode);
  };

  React.useEffect(() => {
    setLeadMetaData();
    return () => leadMetaRequest.abort();
  }, []);

  return (
    <section className={cn.launchGardeniaRegister} id={GARDENIA_BAY_ID}>
      <GardeniaContainer>
        <div className={cn.registerGardeniaBlock}>
          <div className={cn.registerGardeniaHeader}>
            <h2 data-key={'yasRegistrationHeading'}>
              {t['yasRegistrationHeading']}
            </h2>
            <p data-key={'yasRegistrationContent'}>
              {t['yasRegistrationContent']}
            </p>
          </div>

          <LeadForm
            successPopUpLink={props.successPopUpLink}
            privacyPolicyLink={props.privacyPolicyLink}
            termsAndConditionsLink={props.termsAndConditionsLink}
            countryCodes={countryCode}
            t={t}
            nationalities={nationalities}
          />
        </div>
      </GardeniaContainer>
    </section>
  );
}
